import { axiosGet, axiosPost } from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL + '/branch';



const getAllBranches = async ({ limit = 100, page = 0, status = null, sortModel = [], filterModel = [] }) => {
  try {

    let sendStatus = status;
    if (sendStatus === 0) {
      sendStatus = null;
    }
    let search = null;
    if (filterModel['quickFilterValues']) {
      search = filterModel['quickFilterValues'][0] || null;
    }
    const response = await axiosGet(`${BASE_URL}/get`, {
      limit,
      page,
      sendStatus,
      search,
      sort: sortModel,
    });
    return response;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};
const getBranchById = async ({ id = null }) => {
  try {

    const response = await axiosGet(`${BASE_URL}/get/${id}`, {
      params: {
        id
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching branch details:", error);
    throw error;
  }
};

const updateBranchStatus = async (params) => {
  try {

    const dt = { ...params };
    const response = await axiosPost(`${BASE_URL}/status/`, dt);
    return response;
  } catch (error) {
    console.error(`Error updating branch status:`, error);
    throw error;
  }
};

const updateBranchPaymentGatewayConfig = async (params) => {
  const payload = {
    ...params,
  };

  return axiosPost(
    `${BASE_URL}/payment-gateway/config`,
    payload
  );
};

const branchApi = {
  getAllBranches,
  getBranchById,
  updateBranchStatus,
  updateBranchPaymentGatewayConfig,
  // Temporary compatibility
  updateBranchRazorpayConfig: updateBranchPaymentGatewayConfig,
};

export default branchApi;
